import {useDispatch, useSelector} from "react-redux";
import {getDitaContent, selectDitaContent} from "../Content/ContentSlice";
import FAQContent from "./FAQContent";
import { useEffect } from "react";

const FAQApp = () => {
  const content = useSelector(selectDitaContent);
  const dispatch = useDispatch();
  
  useEffect(() => {
    getDitaContent('Changes/FAQs/TG_faqs-non-corporate.ditamap', content, dispatch);
  }, [content, dispatch]);
  
  const faqContent = getDitaContent('Changes/FAQs/TG_faqs-non-corporate.ditamap', content, dispatch);

  return <FAQContent faqContent={faqContent}></FAQContent>;
}

export default FAQApp;